import { InterestRateService } from '@/modules/global-settings/loan-origination/services/loan-policies/interest-rate.service';
import { make } from 'vuex-pathify';
import Logger from '@/lib/logger';

// Instantiate the service
const interestRateService = new InterestRateService();
// Define the state
export const state = {
  interestRateSettings: {}
};
// Define the mutations
export const mutations = {
  ...make.mutations(state)
};
// Define the actions
export const actions = {
  /**
   * Fetch all interest rate settings
   * @async
   * @param {object} context - The store context
   * @returns {Object} - The interest rate settings
   * @private This will update the state with the fetched interest rate settings
   */
  getInterestRate: async ({ commit }) => {
    try {
      const { data } = await interestRateService.getInterestRate();
      commit('SET_INTEREST_RATE_SETTINGS', data);
      return data;
    } catch (error) {
      Logger.error('getting interest rate settings', error);
      throw error;
    }
  },
  /**
   * Updates the interest rate settings
   * @async
   * @param {object} context - The store context
   * @param {object} payload - The interest rate settings payload
   * @returns {void}
   * @private This will update the state with the updated interest rate settings
   */
  updateInterestRate: async ({ commit }, payload) => {
    try {
      const { data } = await interestRateService.updateInterestRate(payload);
      commit('SET_INTEREST_RATE_SETTINGS', data);
    } catch (error) {
      Logger.error('updating interest rate settings', error);
      throw error;
    }
  }
};
